import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import './Layout.css';

import ColorScheme from '../ColorScheme/ColorScheme';
import Navigation from '../Navigation/Navigation';

class Layout extends Component {
	
	componentDidMount() {
		const node = ReactDOM.findDOMNode( this );
		node.scrollTop = 0;
	}
	
	render() {
		let colors = {
			color1: '#000000',
			color2: '#999999',
			titleColor: '#000000'
		};
		
		if( this.props.colors ) {
			colors = { ...this.props.colors }
		}
		
		return (
			<Fragment>
				<ColorScheme { ...colors } />
				<Navigation />
				<main id="Content">
					{ this.props.children }
				</main>
			</Fragment>
		);
	}
}

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js